import { z } from 'zod';
import { createToolSignature } from './tool-signature';

export const webSearchToolSignature = createToolSignature({
    name: 'webSearchTool',
    description: undefined,
    inputSchema: z.object({
        query: z.string().describe('The query to search the web for'),
    }),
    outputSchema: z.object({
        result: z.string().describe('The result of the web search'),
    }),
    toolCallUi: (input) => `Searching the web for ${input.query}`,
});
